import {
  USER_LOGIN,
  USER_LOGOUT,
  TOKEN_LOAD,
  TOKEN_RELEASE,
  REFRESH_LOAD,
  REFRESH_RELEASE
} from './types';


export const userLogin = (user) => {
  return {
    type: USER_LOGIN,
    payload: user
  };
}

export const userLogout = () => {
  return {
    type: USER_LOGOUT
  };
}


export const tokenLoad = (token) => {
  return {
    type: TOKEN_LOAD,
    payload: token
  };
}

export const tokenRelease = () => {
  return {
    type: TOKEN_RELEASE
  };
}


export const refreshLoad = (refresh) => {
  return {
    type: REFRESH_LOAD,
    payload: refresh
  };
}

export const refreshRelease = () => {
  return {
    type: REFRESH_RELEASE
  };
}






// WEBPACK FOOTER //
// ./src/Actions/AuthActions.js